<h1 mat-dialog-title>Code bar scanner</h1>
<div mat-dialog-content>
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 verLector" id="verLector">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" id="codigoRead"></div>
  </div>
</div>
<div mat-dialog-actions>
 <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row">
   <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
    <button mat-raised-button color="danger"     class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" (click)="onNoClick()" id="cancelar">
      Cancel
    </button>
   
   </div>
   <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
    <button
    mat-raised-button
    color="primary"
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
    id="datolector"
    [mat-dialog-close]="data"
    cdkFocusInitial
  >
    Ok
  </button>
   </div>
 </div>
</div>
